export default "__VITE_ASSET__DSjb6nzD__"